
const PlayerRemoteBase = class PS {

    sync(o) {
        this._setPlayPause = o.setPlayPause
        this.canvas = o.canvas;
        this._lock = o.lock
    }

    lock() {
        this.pause();
        this._lock?.(true)
    }

    unlock() {
        this._lock?.(false)
    }

    play() {
        this.unlock?.();
        this._setPlayPause?.(true)
    }

    pause() {
        this._setPlayPause?.(false)
    }


}


export default PlayerRemoteBase;